<div class="container-fluid card p-3 mt-3" *ngIf="!isLoading && meeting">
  <h2 class="mb-3 text-primary">Education Meeting Details</h2>
  <table class="table table-bordered">
    <tbody>
    <tr>
      <th width="30%">Date</th>
      <td>{{ meeting.date.toDate() | date:'dd MMM yyyy' }}</td>
    </tr>
    <tr>
      <th>Place</th>
      <td>{{ meeting.place }}</td>
    </tr>
    <tr>
      <th>Centre</th>
<!--      <td>{{ meeting.centreName }} ({{ meeting.centreCode }})</td>-->

      <td>{{ meeting.centreName }} </td>
    </tr>
    <tr>
      <th>Type</th>
      <td>{{ meeting.type }}</td>
    </tr>
    <tr>
      <th>Descriptions</th>
      <td><textarea class="form-control"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="8" readonly>{{ meeting.content }}</textarea></td>
    </tr>
    <tr>
      <th>Participants</th>
      <td>{{ getParticipantNames() }}</td>
    </tr>
    <tr>
      <th>Suggestions</th>
      <td>
        <!--        <div class="text-content" [innerHTML]="meeting.suggestions"></div>-->

        <div class="text-content" [innerHTML]="renderSuggestions(meeting.suggestions)"></div>

      </td>

    </tr>


    </tbody>
  </table>
  <div class="row justify-content-center d-flex mt-3">
    <div class="col-md-4">
      <button mat-raised-button color="warn" routerLink="/home/education/education-mom-list">
        Back to List
      </button>
    </div>
  </div>
</div>
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="61"></mat-spinner>
</div>


